import type { Dispatch, SetStateAction } from 'react';
import type { IntelligenceReportDataInfo } from '../types';
import { SEARCH_HISTORY_MAX } from '../_constants';
import type { ISearchRecordItem, TReportMutableField } from './types';

export const extractKeywords = (records?: ISearchRecordItem[]): string[] => {
  if (!Array.isArray(records)) {
    return [];
  }
  return records
    .map(item => item?.metric_name)
    .filter((value): value is string => typeof value === 'string' && value.length > 0)
    .slice(0, SEARCH_HISTORY_MAX);
};

export const createReportFieldUpdater = (
  setter: Dispatch<SetStateAction<IntelligenceReportDataInfo[]>>,
) => (
  resourceId: string,
  field: TReportMutableField,
  value: number,
): void => {
  setter(prev =>
    prev.map(item =>
      item.resource_id === resourceId ? { ...item, [field]: value } : item,
    ),
  );
};
